import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const getMember = async (options: Options = {}): Promise<SelfServiceAPI.GetMember.Response> => {
  try {
    const { data } = await axios.get<SelfServiceAPI.GetMember.Response>(`${SELF_SERVICE_API_URL}/member`, {
      withCredentials: true,
    });

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await getMember({ ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `GET /member`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getMember;
